module.exports = "pegasus_template/assets/header-card.png";